import ContentLabPlanBundle from '@/types/models/pricing/contentLabPlanBundle';
import contentStudioSubscriptionFetchers from '@/api/fetchers/content-studio/subscription';
import {
  getPlanVariant,
  getTokenBalance,
} from '@/views/content-studio/pricing/utils';
import getActiveSubscription from '@/views/content-studio/utils/getActiveSubscription';

export const CREDIT_ACCESS_ACTION = {
  NO_OP: 'NO_OP',
  REDIRECT_TO_PRICING: 'REDIRECT_TO_PRICING',
  OPEN_PRICING_MODAL: 'OPEN_PRICING_MODAL',
};

export type CreditAccessAction =
  (typeof CREDIT_ACCESS_ACTION)[keyof typeof CREDIT_ACCESS_ACTION];

/**
 * Resolve the action to take based on the required credits, current subscription balance and subscription plan.
 *  @param requiredCredits
 *  @returns {Promise<CreditAccessAction>} The action to take regarding credit access.
 */
async function resolveCreditAccessAction(
  requiredCredits: number
): Promise<CreditAccessAction> {
  const response = await contentStudioSubscriptionFetchers.current();
  const currentSubscriptions = response.subscriptions;

  const activeSubscription = getActiveSubscription(currentSubscriptions);
  const currentBalance = getTokenBalance(activeSubscription) || 0;
  const activeSubscriptionBundle = getPlanVariant(activeSubscription);

  if (requiredCredits > currentBalance) {
    return activeSubscriptionBundle === ContentLabPlanBundle.FREE
      ? CREDIT_ACCESS_ACTION.REDIRECT_TO_PRICING
      : CREDIT_ACCESS_ACTION.OPEN_PRICING_MODAL;
  }

  return CREDIT_ACCESS_ACTION.NO_OP;
}

export default resolveCreditAccessAction;
